import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import WhatToExpectSection from '../../Components/servicex/WhatToExpectSection';
import WeCanAlsoHelpWithSection from '../../Components/servicex/WeCanAlsoHelpWithSection';

const serviceItems = [
    {
        id: 1,
        title: "Reduce operational costs by eliminating redundancy and system complexity",
        description: "Standardize service and configuration data to eliminate operational blind spots, streamline resolution, and ensure cross-functional alignment.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Increase agility with scalable, enterprise-wide service capabilities",
        description: "Connect business services directly with underlying technical architecture to accelerate change management and rapid digital adoption.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Foster seamless collaboration across departments and workflows",
        description: "Leverage structured data frameworks to gain end-to-end visibility, benchmark service performance, and prioritize high-value IT investments.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    }
];


const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Consulting",
        desc: "We evaluate service delivery across IT, HR, facilities, finance, and beyond to eliminate silos, inefficiencies, and process inconsistencies. Our experts design a unified ESM strategy that standardizes workflows, strengthens governance, enhances visibility, and firmly aligns enterprise services with business objectives.",
        products: []
    },
    {
        id: 2,
        title: "Implementation",
        desc: "We design and deploy ServiceNow Enterprise Service Management solutions to unify requests, streamline workflows, and deliver user-friendly service catalogs with seamless self-service options. This creates a scalable, standardized framework that boosts responsiveness, enhances operational oversight, and ensures consistency across the enterprise.",
        products: []
    },
    {
        id: 3,
        title: "Support and Maintenance",
        desc: "We continuously refine workflows, advance automation, and sharpen reporting to keep enterprise services ahead of evolving demands. With robust governance and advanced performance analytics, we drive relentless efficiency, quantifiable gains, and crystal-clear transparency across every service function.",
        products: []
    },
    {
        id: 4,
        title: "Resource Augmentation",
        desc: "Our certified ServiceNow specialists integrate seamlessly with your teams to accelerate adoption, embed best practices, and strengthen cross-functional collaboration. We help convert enterprise service delivery into a data-driven, scalable engine that advances efficiency, agility, and consistent employee experiences.",
        products: []
    }
];


const industryTabs = [
    {
        id: "it-operations",
        label: "IT Operations",
        title: "IT Operations",
        desc: "Leverage Predictive Intelligence to proactively identify and resolve issues, minimizing downtime and enhancing service reliability.[cite: 27]",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "customer-service",
        label: "Customer Service",
        title: "Customer Service",
        desc: "Deploy Virtual Agents to provide instant, 24/7 support, reducing case volumes and improving customer satisfaction.[cite: 27]",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "human-resources",
        label: "Human Resources",
        title: "Human Resources",
        desc: "Automate onboarding, manage employee inquiries, and personalize HR services, fostering a more engaged workforce.[cite: 27]",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "security-operations",
        label: "Security Operations",
        title: "Security Operations",
        desc: "Utilize AI-driven analytics to detect threats, automate incident responses, and maintain robust security postures.[cite: 27]",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: "finance-procurement",
        label: "Finance and Procurement",
        title: "Finance and Procurement",
        desc: "Streamline invoice processing and procurement workflows through intelligent automation, enhancing accuracy and efficiency.[cite: 27]",
        image: "/assets/mumbai/item2.png",
        link: "#"
    },
    {
        id: "facilities-management",
        label: "Facilities Management",
        title: "Facilities Management",
        desc: "Optimize space utilization and maintenance schedules with AI-powered insights, ensuring operational excellence.[cite: 27]",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Unified Service Delivery",
        desc: "Unified service delivery across IT, HR, Facilities, and Finance"
    },
    {
        id: 2,
        title: "Scalable Workflows",
        desc: "Standardized, scalable workflows that boost operational consistency"
    },
    {
        id: 3,
        title: "Built-In Governance",
        desc: "Service governance and compliance built into every implementation"
    },
    {
        id: 4,
        title: "Actionable Insights",
        desc: "Actionable insights to improve performance and decision-making"
    }
];

const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "What is the difference between ITSM and ESM?",
        answer: "ITSM focuses on IT service delivery, while ESM extends service management practices across HR, finance, facilities, and other departments for enterprise-wide efficiency."
    },
    {
        id: 2,
        question: "Why choose ESM for department-specific tools?",
        answer: "ESM eliminates silos, standardizes processes, improves visibility, and delivers consistent, automated services across the organization."
    },
    {
        id: 3,
        question: "How does Aelum ensure a smooth transition to ESM?",
        answer: "Aelum assesses workflows, aligns processes, and implements ServiceNow ESM with minimal disruption, guided by practitioner-led expertise and best practices."
    },
    {
        id: 4,
        question: "Can ServiceNow ESM integrate with legacy systems?",
        answer: "Yes. ServiceNow ESM supports integration with existing enterprise systems, ensuring seamless data flow and unified service delivery."
    },
    {
        id: 5,
        question: "How do Aelum’s Pod services support ESM?",
        answer: "Our Pods embed certified experts within your teams, providing ongoing support, optimization, and adoption guidance for scalable, efficient enterprise service operations."
    }
];


const expectItems = [
    "Unified Enterprise Service Portal",
    "Standardized Service Catalogs",
    "Automated Cross-Department Workflows",
    "Self-Service and Virtual Agent Experiences",
    "Performance Analytics and Service Insights"
];


function ServiceManagement() {
    return (
        <div>
            <WhoHero
                title="ServiceNow Enterprise Service Management"
                text="Equip Every Team with Intelligent, Unified Service Management"
                imgData="/assets/glodesk/bg2.png"
            />
            {/* <UserFirstExperienceSection title="Your productivity with ServiceNow AI" description="The AI era is advancing faster than we ever imagined, quickly becoming the driving force behind modern enterprises—fuelling progress with every insight and breakthrough. The real advantage lies in how efficiently and effectively an organization delivers value to both its customers and employees. To make impossible possible, businesses need a trusted partner like Aelum Consulting to shape and implement AI solutions that carve out a unique, transformative path. With the power of ServiceNow AI, we connect and automate workflows across your entire enterprise, unifying AI, data, and processes on a single, intelligent platform. This seamless integration not only streamlines operations but also empowers your teams to focus on what truly matters—driving growth and delivering exceptional value." /> */}
            <ServiceX360ViewSection title="Get Consistent, Connected Services Across the Enterprise with ServiceNow Enterprise Service Management" description="Disjointed platforms and manual handoffs limit service performance and enterprise agility. Aelum helps you implement ServiceNow enterprise service management to centralize service requests, standardize workflows, and establish a single, enterprise-wide service model across IT, HR, facilities, finance, and beyond. By eliminating silos and automating repetitive processes, we make services accessible, responsive, and strategically aligned. With intelligent service catalogs, self-service portals, and actionable insights, your teams gain visibility, control, and the agility to resolve issues faster, optimize resources, and scale operations with confidence, delivering measurable gains in efficiency, satisfaction, and service reliability." serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our ServiceNow Enterprise Service Management Services" description="Create Seamless Enterprise Service Experiences with ServiceNow Enterprise Service Management" />
            <WhatToExpectSection title="What to expect from ServiceNow Enterprise Service Management" description="" expectItems={expectItems} />
            <WeCanAlsoHelpWithSection />
            {/* <IndustriesServiceExperienceSection title="ServiceNow AI for Every Corner of Your Business" industryTabs={industryTabs} /> */}
            <WhatSetsApartSection title="Why Mobikode for ServiceNow Enterprise Service Management?" description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            {/* <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} /> */}
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default ServiceManagement
